import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';


const CoverImageUpload = ({businessFromAdmin}) => {
  const [selectImage, setSelectImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);
  const [coverImage, setCoverImage] = useState([]);
  const { business } = useAuth();

  const currentBusiness = businessFromAdmin || business;

  // 🔁 Přesuneme fetchCoverImage mimo useEffect, aby šel zavolat i později
  const fetchCoverImage = useCallback(async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/images/public-images`, {
        params: { businessId: currentBusiness._id, isCover: "true" }
      });
      setCoverImage(response.data.images);
    } catch (err) {
      setMessage("Úvodní obrázek zatím nebyl nahrán");
    }
  }, [currentBusiness]);
  
  useEffect(() => {
    if (currentBusiness._id) {
      fetchCoverImage();
    }
  }, [currentBusiness._id, fetchCoverImage]);



  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setMessage("Prosím vyberte obrázek.");
      return;
    }
    setSelectImage(file);
    await handleUpload(file);
  };

  const handleUpload = async (file) => {
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("image", file);
    formData.append("businessId", currentBusiness?._id);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/images/cover-upload`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log(selectImage)
      setMessage(response.data.message);
      setSelectImage(null);

      // ✅ Místo reload zavoláme fetchCoverImage pro aktualizaci
      await fetchCoverImage();

    } catch (error) {
      setMessage(error.response?.data?.message || "Chyba při nahrávání obrázku.");
      console.error("Chyba při nahrávání:", error);
    } finally {
      setUploading(false);
      setTimeout(() => {
        setMessage(null)
        fetchCoverImage()
      }, 2000);
    }
  };

  return (
    <div>
      <p>Ideální formát 16:9</p>
      <input
        type="file"
        id="CoverFileInput"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden-input"
      />
      <button
        className="profile-button"
        onClick={() => document.getElementById("CoverFileInput").click()}
        disabled={uploading}
      >
        {uploading ? "Nahrávání..." : "Vybrat obrázek"}
      </button>

      {!uploading && (
        <>
          {coverImage.map((img) => (
            <div key={img._id} className='cover-image-gallery'>
            <div className='image-wrapper zeromargin'>
              <img src={img.fileUrl} alt={`cover-image-${img._id}`} />
            </div>
          </div>
          ))}
        </>
      )}

      {uploading && <div className="loading-spinner center-spinner zeromargin"></div>}
      {message && <p className="message">{message}</p>}
    </div>
  );
};
export default CoverImageUpload;